import { Link } from "react-router-dom"
import { Layout } from "@/components/Layout"
import { PageHeader } from "@/components/PageHeader"
import { useWelcomeOfferSettings, useWelcomeOffers } from "@/hooks/useWelcomeOffers"

export function Offers() {
  const { data } = useWelcomeOffers("details_received", "", 0)
  const { data: settings } = useWelcomeOfferSettings()

  return (
    <Layout>
      <div className="space-y-8">
        <PageHeader title="Offers" description="Review offer requests and follow up with coaches." />
        <section aria-labelledby="diagrams-offers" className="space-y-4">
          <h2 id="diagrams-offers" className="text-lg font-semibold">Diagrams</h2>
          <Link
            to="/offers/diagrams"
            className="block max-w-2xl rounded-xl border border-border bg-surface p-6 transition-colors hover:bg-muted/30 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
          >
            <h3 className="font-semibold">
              Free year of Playside film
              {settings?.paused && (
                <span className="ml-2 rounded-full bg-amber-500/15 px-2.5 py-1 text-xs font-medium text-amber-700 dark:text-amber-300">
                  Paused
                </span>
              )}
            </h3>
            <p className="mt-2 text-sm text-secondary">
              Welcome offer for coaches who sign up through Diagrams.
            </p>
            {data && (
              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm">
                <span className="font-medium">{data.counts.details_received} ready for review</span>
                <span className="text-secondary">{data.claimed_count} of {data.cap} spots claimed</span>
              </div>
            )}
            <span className="mt-5 inline-block text-sm font-medium text-blue-600">View requests →</span>
          </Link>
        </section>
      </div>
    </Layout>
  )
}
